export default {
    meta: {
        title: '拓店宝-草稿箱'
    }
};
